__turbopack_context__.v({
  "article": "article-module__9-jrzG__article",
  "backlink": "article-module__9-jrzG__backlink",
  "lead": "article-module__9-jrzG__lead",
  "main": "article-module__9-jrzG__main",
  "meta": "article-module__9-jrzG__meta",
  "metaIcon": "article-module__9-jrzG__metaIcon",
  "more": "article-module__9-jrzG__more",
  "moreIconBox": "article-module__9-jrzG__moreIconBox",
  "moreItem": "article-module__9-jrzG__moreItem",
  "moreItemBody": "article-module__9-jrzG__moreItemBody",
  "moreItemDesc": "article-module__9-jrzG__moreItemDesc",
  "moreItemTitle": "article-module__9-jrzG__moreItemTitle",
  "moreList": "article-module__9-jrzG__moreList",
  "moreTitle": "article-module__9-jrzG__moreTitle",
  "prose": "article-module__9-jrzG__prose",
  "title": "article-module__9-jrzG__title",
});
